import Sidebar from "./Sidebar"
import { Location, NavigateFunction } from "react-router-dom"

import { memo, useState } from "react"
import styled from "styled-components"
import clsx from "clsx"
import GlobalToast from "../../EvtKit/Toast/GlobalToast"

export const BeatSidebarWrapper = styled.div``
export const BeatSidebarContent = styled.div`
  padding-left: 304px;
  overflow-x: hidden;

  &.collapsed {
    padding-left: 108px;
  }
`

interface BeatLayoutProps extends App.SidebarProps {
  location: Location
  navigate: NavigateFunction
}

const BeatLayout = ({
  logoURL,
  options,
  actionOptions,
  children,
  className,
  location,
  navigate,
  isCollapsable = false
}: BeatLayoutProps) => {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <BeatSidebarWrapper>
      <GlobalToast />
      <Sidebar
        logoURL={logoURL}
        options={options}
        actionOptions={actionOptions}
        location={location}
        navigate={navigate}
        className={className}
        collapsed={collapsed && isCollapsable}
        isCollapsable={isCollapsable}
        setCollapsed={setCollapsed}
      />
      <BeatSidebarContent className={clsx({ collapsed })}>{children}</BeatSidebarContent>
    </BeatSidebarWrapper>
  )
}

export default memo(BeatLayout)
